<template>
    <div class="modal" style="display: flex">
        <div class="modal-background" @click="$root.$children[0].toggleHelpScreen()"></div>
        <div class="modal-card">
            <section class="modal-card-body">
                <h2 class="is-size-4">Créditos</h2><br/>
                Design e programação:<br/>
                Marcelo Gomes Jr<br/>
                <br/>
                Roteiro e idealização:<br/>
                <b><a target="_blank" href="https://ricardokuraoka.itch.io/">Ricardo Kuraoka</a></b><br/>
                <br/>
                Foto da tela inicial:<br/>
                <b><a target="_blank"
                      href="https://www.pexels.com/photo/woman-wearing-tank-top-sitting-by-the-window-920381">Bruce
                    Mars
                    hospedada no site Pexels</a></b><br/>
                <br/>
                Fonte usada no título do site:<br/>
                <b><a target="_blank"
                      href="https://fonts.google.com/specimen/Roboto">Roboto</a></b><br/>
                <br/>
                Avatares por <b><a target="_blank" href="http://avatars.adorable.io/">Adorable Avatars</a></b><br/>
                <br/>
                Desenvolvido com <b><a target="_blank" href="https://vuejs.org/">Vue.js</a></b> e <b><a target="_blank"
                                                                                                        href="https://bulma.io/">Bulma</a></b>
            </section>
        </div>
        <button class="modal-close is-large" aria-label="close"
                @click="$root.$children[0].toggleHelpScreen()"></button>
    </div>
</template>

<script>
    export default {
        name: 'HelpScreen'
    }
</script>

<style scoped>
</style>